export default "__VITE_ASSET__efe990e2__"